import axiosPost from "./axiosPost";

export const SFHabitacionIns = async (credentials, data) => {
    const body = {
        service: "SFHabitacionIns",
        params: {
            SFHotelId: data.SFHotelId,
            SFHabitacionNumero: data.SFHabitacionNumero,
            SFHabitacionPiso: data.SFHabitacionPiso,
            SFHabitacionPlazas: data.SFHabitacionPlazas,
            SFHabitacionGenero: data.SFHabitacionGenero,
        },
    };

    const result = await axiosPost(body, credentials);
    if (result?.status?.code === 0) {
        return [result.status];
    }
    return result.result;
};
